<template>
  <div class="select-page">
    <div
      class="select-container"
      v-pageBuried
      data-page-buried="BG_BUJILIEBIAO"
      :style="{ height: screenHeight + 'px' }"
    >
      <AppNavBar
        title="选择我的营养品"
        :placeholder="true"
        :options="options"
      ></AppNavBar>
      <!--  <div class="top-consult">
                <img class="consult-image"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cfc92470fe381bb06b657309acf66ed4.png" alt="">
                <div class="consult-btn" @click="bindConsult" v-clickBuried data-click-buried="CLICK_BUJILIEBIAO_UPJINXIAN">
                </div>
            </div> -->
      <HomeSearch @search="bindSearch" @tab="bindIntoSearch" />
      <div class="select-content">
        <div class="select-nav" v-if="tabList && tabList.length">
          <van-sidebar
            v-model="activeKey"
            class="slider-bar"
            @change="bindTabChange"
          >
            <van-sidebar-item
              :title="item.title"
              v-for="(item, index) in tabList"
              :key="index"
            />
          </van-sidebar>
        </div>
        <div class="select-wrapper">
          <div
            v-for="(item, index) in tabList"
            :key="index"
            class="select-template"
            :class="{ 'select-template-active': index == activeKey }"
          >
            <div v-show="index == activeKey" class="select-scorll">
              <van-list
                v-model="item.loading"
                :finished="item.finished"
                @load="getData"
              >
                <div class="bj-list">
                  <SelectBujiItem
                    class="bj-item"
                    v-for="(item1, index1) in item.list"
                    :key="index1"
                    :data="item1"
                    @icon="bindClickIcon"
                    @add="bindClickAdd"
                    @del="bindDeleteBuji"
                    @detail="bindClickTonicItem"
                  >
                  </SelectBujiItem>
                </div>
              </van-list>
              <!-- <div class="nav-consult" v-if="item.finished" v-buried data-buried="BG_BUJILIEBIAO_DOWNJINXIAN"
                                v-clickBuried data-click-buried="CLICK_BUJILIEBIAO_DOWNJINXIAN">
                                <div class="consult-btn" @click="bindConsult"></div>
                                <img class="consult-image"
                                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5c2d16bb3f684933af024da83f7e0c14.png"
                                    alt="">
                            </div> -->
              <!--  <AppLoading v-if="item.loading" class="nav-loading" /> -->
            </div>
          </div>
        </div>
      </div>
      <ShopCard
        @submit="submitPlan"
        :create="!planId"
        :data="curSelectList"
        @delete="bindDeleteBuji"
      />
      <van-overlay
        :show="showSelectMethods"
        @click="showSelectMethods = false"
        z-index="5001"
      >
        <SelectMethodsPopup
          :data="selectMethodsData"
          @add="bindAddBuji"
          @close="bindCloseSelectToast"
        />
      </van-overlay>
      <van-overlay :show="showCreateLoading" z-index="5002">
        <CreateLoading :type="loadingType" />
      </van-overlay>
      <van-popup
        v-model="showTonicDetail"
        position="bottom"
        round
        class="plan-list-popup"
        z-index="5003"
      >
        <TonicDetail :id="tonicId" v-if="showTonicDetail" />
      </van-popup>
    </div>
    <AppLoading v-if="!tabLoaded" class="app-loading" />
    <!-- <van-overlay :show="showSearch" @click="showSearch = false" z-index="5001">
            <SearchComponent v-if="showSearch"  @back="showSearch=false" />
        </van-overlay> -->
  </div>
</template>

<script>
import { jumpToMiniProgram } from './data.js'
import { addCartAnimate } from '@/components/add-cart-animate/index'
import TonicDetail from './components/tonic-detail.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import AppLoading from '@/components/app/loading/loading.vue'
import SelectBujiItem from './components/select-buji-item.vue'
import SelectMethodsPopup from './components/select-methods-popup.vue'
import CreateLoading from './components/create-loading.vue'
import HomeSearch from './components/home-search.vue'
import ShopCard from './components/shop-card.vue'
export default {
  components: {
    AppLoading,
    AppNavBar,
    SelectBujiItem,
    ShopCard,
    SelectMethodsPopup,
    CreateLoading,
    TonicDetail,
    HomeSearch
  },
  data() {
    return {
      screenHeight: window.screen.height,
      options: {
        barBackgroundColor: 'rgba(249, 249, 249, 1)'
      },
      planId: 0,
      tabLoaded: false,
      activeKey: 0,
      tabList: [],
      showPlanListToast: false,
      showSelectMethods: false, //选择方案弹窗
      selectMethodsData: null, //选择补剂方案数据
      showCreateLoading: false,
      loadingType: 1,
      showTonicDetail: false, //显示补剂详情
      tonicId: 0,
      showSearch: false,
      searchValue: ''
    }
  },
  provide() {
    return {
      getCurSelectList: () => this.curSelectList,
      addBuji: (item, index) => {
        this.bindAddBuji(item, index)
      },
      deleteBuji: (item) => this.bindDeleteBuji(item),
      clickTonicItem: (item) => {
        this.bindClickTonicItem(item)
      },
      submitPlan: () => {
        this.submitPlan()
      }
    }
  },
  computed: {
    curSelectList() {
      return this.$store.state.nutritionClock.selectList
    }
  },
  created() {
    this.planId = this.$route.query.planId
    this.getTabData()
  },
  methods: {
    bindIntoSearch(item) {
      this.$router.push({
        path: '/nutrition-clock/search',
        query: {
          keyword: item,
          planId: this.planId
        }
      })
    },
    bindSearch(item) {
      this.$router.push({
        path: '/nutrition-clock/search',
        query: {
          autoSearch: 1,
          keyword: item,
          planId: this.planId
        }
      })
    },
    bindConsult() {
      jumpToMiniProgram()
    },
    resetSelectList() {
      this.$store.commit('nutritionClock/clearSelectList')
    },
    bindClickTonicItem(item) {
      this.tonicId = item.product_id
      this.showTonicDetail = true
    },
    bindDeleteBuji(item) {
      item.select = false
      item.curSelect = undefined
      this.$store.commit('nutritionClock/deleteSelectList', item)
    },
    bindAddBuji(item, index, event) {
      if (event) {
        const cartEl = document.getElementById('shop-card-icon')
        const addEl = event?.target
        addCartAnimate(addEl, cartEl)
      }
      this.showSelectMethods = false
      item.select = true
      item.curSelect = index
      this.$store.commit('nutritionClock/addSelectList', item)
      this.updatePlanData()
    },
    bindCloseSelectToast() {
      this.showSelectMethods = false
    },
    bindTabChange() {
      this.getData()
    },
    bindClickIcon(item) {},
    bindToggleToast() {
      if (!this.curSelectList.length) {
        return
      }
      this.showPlanListToast = !this.showPlanListToast
    },
    submitPlan() {
      if (this.planId) {
        this.editPlan()
      } else {
        this.createPlan()
      }
    },
    /* 编辑补剂计划 */
    async editPlan() {
      let list = this.filterSubmitData(this.curSelectList)
      let params = {
        detail: JSON.stringify(list),
        plan_id: this.planId
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/addUsageRule', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.resetSelectList()
          this.$toast('添加成功')
          setTimeout(() => {
            this.$http.appBack()
          }, 500)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 创建补剂计划 */
    async createPlan() {
      this.loadingType = 1
      this.showCreateLoading = true
      let list = this.filterSubmitData(this.curSelectList)
      let params = {
        detail: JSON.stringify(list)
      }
      /* 动画播放时间 */
      let promise1 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      let promise2 = this.$http.postBaseApp(
        'api/v1/TonicPlanOperate/addCustomPlan',
        params
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {
        this.showCreateLoading = false
      })
      if (res) {
        let res1 = res[1].data
        if (res1.code == 200) {
          this.resetSelectList()
          /* 更新计划数据id */
          let planId = res1.data?.plan_id
          if (planId) {
            this.$store.commit('nutritionClock/setPlanDataId', planId)
          } else {
          }
          this.backHome()
        } else {
          this.$toast(res1.msg)
          this.showCreateLoading = false
        }
      }
    },
    /* 返回首页 */
    backHome() {
      this.$store.commit('nutritionClock/setShowActivityToast', true)
      this.$router.go(-1)
    },
    filterSubmitData(data) {
      let res = data.map((item) => {
        let obj = {
          tonic_product_id: item.product_id,
          daily_times: item.usage[item.curSelect].daily_times,
          every_times_num: item.usage[item.curSelect].every_times_num,
          take_suggested_time: item.usage[item.curSelect].take_suggested_time,
          time_details: item.usage[item.curSelect].time_details
        }
        return obj
      })
      return res || []
    },
    bindClickAdd(item, event) {
      if (event) {
        const cartEl = document.getElementById('shop-card-icon')
        const addEl = event?.target
        addCartAnimate(addEl, cartEl)
      }
      if (item.usage.length > 1) {
        this.selectMethodsData = item
        this.showSelectMethods = true
      } else {
        item.select = true
        item.curSelect = 0
        this.$store.commit('nutritionClock/addSelectList', item)
        this.updatePlanData()
      }
    },
    async getTabData() {
      let params = {}
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/tonicEfficacyList', params)
        .catch(() => {})
      this.tabLoaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.tabList = this.dealData(res.data)
          this.getData()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    dealData(data) {
      data.map((item) => {
        item.loading = false
        item.finished = false
        item.loaded = false
        item.page = 1
        item.list = []
      })
      return data
    },
    async getData() {
      let index = this.activeKey
      if (this.tabList[index].finished) {
        return
      }
      let params = {
        efficacy_id: this.tabList[index].id,
        plan_id: this.planId,
        page: this.tabList[index].page,
        size: 20
      }
      this.tabList[index].loading = true
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/tonicListByEfficacyByPlan', params)
        .catch((err) => {
          this.tabList[index].finished = true
        })
      this.tabList[index].loading = false
      this.tabList[index].loaded = true
      if (res) {
        res = res.data
        // res.data = deepClone(NavData);
        if (res.code == 200) {
          this.tabList[index].page++
          if (res.data.length) {
            this.tabList[index].list = this.tabList[index].list.concat(
              this.initPlanData(res.data)
            )
          } else {
            this.tabList[index].finished = true
          }
        } else {
          this.$toast(res.msg)
          this.tabList[index].finished = true
        }
      }
    },
    /* 初始化计划数据 */
    initPlanData(data) {
      let selectIds = this.curSelectList.map((item) => {
        return item.product_id
      })
      data.map((item) => {
        item.select = selectIds.includes(item.product_id)
        item.curSelect = undefined
      })
      return data
    },
    //更新计划数据
    updatePlanData() {
      let selectIds = this.curSelectList.map((item) => {
        return item.product_id
      })
      this.tabList.map((item) => {
        item.list.map((item1) => {
          item1.select = selectIds.includes(item1.product_id)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.select-page {
  .select-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100vh;

    .top-consult {
      position: relative;
      height: 42px;

      .consult-image {
        width: 100%;
        height: 100%;
      }

      .consult-btn {
        position: absolute;
        width: 112px;
        height: 26px;
        top: 8px;
        right: 12px;
      }
    }

    .nav-consult {
      margin: 0px auto 30px;
      width: 208px;
      height: 37px;
      position: relative;

      .consult-image {
        width: 100%;
        height: 100%;
      }

      .consult-btn {
        width: 70px;
        height: 20px;
        position: absolute;
        top: 10px;
        right: 20px;
      }
    }

    .select-content {
      position: relative;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: stretch;

      .select-nav {
        width: 84px;
        height: 100%;
        background: #f9f9f9;
        overflow-y: scroll;

        ::v-deep .van-sidebar-item {
          text-align: center;
          padding: 15px 12px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }

        ::v-deep .van-sidebar-item--select {
          color: rgba(0, 0, 0, 0.8);
          font-weight: bold;
        }

        ::v-deep .van-sidebar-item--select::before {
          display: none;
        }

        .slider-bar {
          width: 100%;
        }
      }

      .select-wrapper {
        position: relative;
        flex: 1;
        height: 100%;
        flex-shrink: 0;
        overflow: hidden;

        .select-template {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .select-template-active {
          z-index: 2;
        }

        .select-scorll {
          position: relative;
          height: 100%;
          overflow-y: scroll;

          .nav-loading {
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translate(-50%, -50%);
          }

          .bj-list {
            padding: 24px 0px;

            .bj-item {
              margin-bottom: 20px;
            }

            .bj-item:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .bottom {
      position: relative;
      z-index: 5000;
      background: #ffffff;
      box-shadow: 0px 0px 0px 0px #f2f2f2;
      padding: 8px 16px 0px;
      @include paddingBottom(6px);

      .fixed {
        height: 44px;
        border-radius: 22px;
        background: #ffffff;
        position: relative;
        z-index: 5000;
        display: flex;
        align-items: center;

        .b-left {
          border-radius: 22px 0px 0px 22px;
          background: #222426;
          height: 100%;
          flex: 1;
          flex-shrink: 0;
          overflow: visible;
          display: flex;
          align-items: flex-end;

          .clock-wrapper {
            margin-left: 10px;
            margin-right: 6px;
            width: 48px;
            height: 48px;
            position: relative;

            .flag {
              position: absolute;
              right: 0;
              top: 0;
              min-width: 16px;
              box-sizing: border-box;
              padding: 0px 4px;
              height: 16px;
              white-space: nowrap;
              text-align: center;
              line-height: 16px;
              background: #fc4444;
              border-radius: 50%;
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }

        .bottom-icon {
          width: 100%;
          height: 100%;
        }

        .clock-gray {
          filter: grayscale(100%);
        }

        .info-wrapper {
          margin-right: 4px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .info {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            color: #ffffff;
            line-height: 17px;
          }

          .iconfont {
            border-radius: 50%;
            box-sizing: border-box;
            width: 12px;
            height: 12px;
            font-size: 12px;
            background: #ffffff;
            border: 1px solid #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 18px;
            transition: 0.3s all ease;
            margin-left: 5px;
          }

          .detail {
            font-size: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #fff;
            line-height: 14px;
          }
        }

        .rotate {
          transform: rotate(180deg);
        }

        .create-btn {
          width: 114px;
          height: 100%;
          background: linear-gradient(
            269deg,
            #6dfdc7 0%,
            #3edcf3 26%,
            #3cb6ff 100%
          );
          border-radius: 0px 26px 26px 0px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .disabled-create {
          background: linear-gradient(
            269deg,
            #6dfdc7 0%,
            #3edcf3 26%,
            #3cb6ff 100%
          );
        }
      }
    }
  }
}

.app-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.create-loading {
  position: fixed;
  left: 0%;
  top: 0%;
}
</style>
